const REDUCER = "@ADMIN/";

const actions = {
  GET_LIST_ADMIN: `${REDUCER}GET_LIST_ADMIN`,
  SET_LIST_ADMIN: `${REDUCER}SET_LIST_ADMIN`,
  SET_IS_LOADING: `${REDUCER}SET_IS_LOADING`,
  SET_CURRENT_ADMIN: `${REDUCER}SET_CURRENT_ADMIN`,
};
export default actions;
